/**
 * Self-funding sequence, step 3: account details. Hosts the shared account-capture screen with the
 * consumer's live funding sources; accounts save to the client's funding sources as they are entered.
 * At least one complete self-funding account is required before the projection. Partner shares are
 * locked by the funding-source rule alone (no guided session is read). Opened from Your Plan, Back
 * returns there; any return point carries on through the projection.
 */
import { FundingSourceAccounts } from '@/features/funding-sources';
import { FundingScreenFrame } from '../components/funding-screen-frame';
import { useConsumerFlow } from '../hooks/use-consumer-flow';
import { useSelfFundingSequence } from '../hooks/use-self-funding-sequence';
import type { ConsumerStepProps } from './step-props';

export function AssessmentAccountsStep({ clientId }: ConsumerStepProps) {
  const { goWithin, finish, returnTo } = useConsumerFlow(clientId);
  const sequence = useSelfFundingSequence(clientId);

  return (
    <FundingSourceAccounts
      selectedTypes={sequence.selectedTypes}
      fundingSources={sequence.fundingSources}
      isLoading={sequence.isLoading}
      isSaving={sequence.isSourceSaving}
      saveError={sequence.saveError}
      readOnly={false}
      requireSelfFundingAccount
      fullWidth
      onContinue={() => goWithin('assessment-projection')}
      onBack={() =>
        returnTo === 'your-plan' ? finish('assessment-intro') : goWithin('assessment-intro')
      }
      frame={parts => (
        <FundingScreenFrame
          step="assessment-accounts"
          parts={parts}
        />
      )}
    />
  );
}
